<template>
  <multiselect
    v-model="selectedCompanies"
    label="name"
    track-by="id"
    placeholder="Select company"
    open-direction="bottom"
    :options="companies"
    :multiple="multiple"
    :searchable="true"
    :allow-empty="!required"
    :loading="isLoading"
    :internal-search="false"
    :clear-on-select="false"
    :preserve-search="true"
    :close-on-select="!multiple"
    :options-limit="300"
    :limit="3"
    :limit-text="limitText"
    :max-height="600"
    :show-no-results="true"
    :hide-selected="multiple"
    @search-change="asyncFind">
    <template slot="clear" slot-scope="props">
      <div class="multiselect__clear" v-if="hasSelected" @mousedown.prevent.stop="clearAll(props.search)"></div>
    </template>
    <template slot="noOptions">Type to search</template>
    <span slot="noResult">No result found. Consider changing the search query.</span>
  </multiselect>
</template>
<style>
</style>

<script>
import Multiselect from 'vue-multiselect';
import { debounce, isObject, sortBy } from 'lodash';
import { matchSorter } from 'match-sorter';

export default {
  components: { Multiselect },
  data() {
    return {
      initSelected: false,
      selectedCompanies: null,
      searchQuery: '',
    };
  },
  props: {
    type: {
      type: String,
      required: false,
      default: '',
    },
    having: {
      type: String,
      required: false,
      default: '',
    },
    multiple: {
      type: Boolean,
      required: false,
      default: true,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    onlineSearch: {
      type: Boolean,
      required: false,
      default: false,
    },
    initSelectionId: {
      type: String,
      required: false,
      default: '',
    },
  },
  created() {
    this.$store.commit('company_select/LOAD_EMPTY_QUERY', !this.onlineSearch);
    this.$store.commit('company_select/SET_QUERY_TYPE', this.type);
    this.$store.commit('company_select/SET_QUERY_HAVING', this.having);
    this.$store.dispatch('company_select/FREE_SEARCH_DATA', { value: '' });
  },
  computed: {
    companies() {
      const companies = this.$store.getters['company_select/companies'];
      if (this.searchQuery === null || this.searchQuery.trim() === '') {
        return sortBy(companies, [(c => c.name.trim())]);
      }
      const q = this.searchQuery.trim().toLowerCase();
      const fComp = companies.filter(c => c.name.toLowerCase().indexOf(q) > -1);
      return matchSorter(fComp, this.searchQuery, { keys: ['name'] });
    },
    isLoading() {
      return this.$store.getters['company_select/isLoading'];
    },
    hasSelected() {
      if (this.multiple) {
        return this.selectedCompanies && this.selectedCompanies.length;
      }
      return isObject(this.selectedCompanies);
    },
  },
  watch: {
    selectedCompanies(selected) {
      this.$emit('on-selected', selected);
    },
    companies(values) {
      this.initSelection(values);
    },
  },
  methods: {
    limitText(count) {
      return `and ${count} other companies`;
    },
    initSelection(companies) {
      if (!this.initSelected) {
        if (this.multiple && this.initSelectionId !== '') {
          const ids = this.initSelectionId.split(',').map(id => parseInt(id, 10));
          this.selectedCompanies = companies.filter(c => ids.indexOf(parseInt(c.id, 10)) > -1);
        } else if (this.initSelectionId !== '') {
          const id = parseInt(this.initSelectionId, 10);
          this.selectedCompanies = companies.find(c => id === parseInt(c.id, 10));
        }
        this.initSelected = true;
      }
    },
    asyncFind: debounce(function asyncFind(query) {
      if (this.onlineSearch) {
        this.$store.dispatch('company_select/FREE_SEARCH_DATA', { value: query });
        return;
      }
      this.searchQuery = query;
    }, 5e2),
    clearAll() {
      this.selectedCompanies = [];
    },
  },
};
</script>
<style lang="css">
.multiselect {
  height: 35px;
  min-height: 35px;
  max-height: 35px;
}

.multiselect__select {
  height: 35px;
  min-height: 35px;
  max-height: 35px;
}

.multiselect__tags {
  height: 35px;
  min-height: 35px;
  max-height: 35px;
  padding: 5px 40px 0 8px;
}

.multiselect__placeholder {
  margin-bottom: 0;
  padding-top: 0;
  padding-bottom: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/CompanyMultiSelect.vue